<template>
  <svg
    :width="width"
    :height="height"
    viewBox="0 0 48 48"
    fill="currentColor"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M10 10C10 8.89543 10.8954 8 12 8C27.4646 8 40 20.5354 40 36C40 37.1046 39.1046 38 38 38C36.8954 38 36 37.1046 36 36C36 22.7446 25.2554 12 12 12C10.8954 12 10 11.1046 10 10ZM10 22C10 20.8954 10.8954 20 12 20C16.2435 20 20.3131 21.6857 23.3137 24.6863C26.3143 27.6869 28 31.7565 28 36C28 37.1046 27.1046 38 26 38C24.8954 38 24 37.1046 24 36C24 32.8174 22.7357 29.7652 20.4853 27.5147C18.2348 25.2643 15.1826 24 12 24C10.8954 24 10 23.1046 10 22ZM9.17157 33.1716C9.92172 32.4214 10.9391 32 12 32C13.0609 32 14.0783 32.4214 14.8284 33.1716C15.5786 33.9217 16 34.9391 16 36C16 37.0609 15.5786 38.0783 14.8284 38.8284C14.0783 39.5786 13.0609 40 12 40C10.9391 40 9.92172 39.5786 9.17157 38.8284C8.42143 38.0783 8 37.0609 8 36C8 34.9391 8.42143 33.9217 9.17157 33.1716Z"
    />
  </svg>
</template>

<script lang="ts">
export default {
  name: "IconPuzzle",
  props: ["height", "width"],
}
</script>
